import { BotType } from "@shared/types";
import { BotType as AvoBotType, BotTypeValueType } from "analytics/Avo";
import { mapValues } from "lodash";
import {
  BASE_DCA_BOTS_PATH,
  GRID_BOT_PATH,
  SIGNALS_BOT_PATH,
  TRADING_VIEW_BOT_PATH,
} from "common/constants";
import { BotsTab } from "@shared/features/bots/types";

export const BOT_TYPE_AVO_MAPPING: Record<BotType, BotTypeValueType> = {
  [BotType.ASAP]: AvoBotType.DCA,
  [BotType.TRADING_VIEW]: AvoBotType.TRADING_VIEW,
  [BotType.SIGNAL]: AvoBotType.SIGNALS,
  [BotType.GRID]: AvoBotType.GRID,
};

export const BOT_TYPE_TO_BASE_PATH: Record<BotType, string> = {
  [BotType.ASAP]: BASE_DCA_BOTS_PATH,
  [BotType.TRADING_VIEW]: TRADING_VIEW_BOT_PATH,
  [BotType.SIGNAL]: SIGNALS_BOT_PATH,
  [BotType.GRID]: GRID_BOT_PATH,
};

export const BOT_TYPE_TO_BASE_BACKTESTING_PATH: Record<BotType, string> =
  mapValues(BOT_TYPE_TO_BASE_PATH, (path) => path + "/backtesting");
export const BOT_TYPE_TO_BASE_MY_BOTS_PATH: Record<BotType, string> = mapValues(
  BOT_TYPE_TO_BASE_PATH,
  (path) => path + `/${BotsTab.MY_BOTS}`
);

export const BOTS_PAGE_LAYOUT_CHANGE_KEY = "bots_page_layout";

export const BOT_TYPE_TO_DESCRIPTION: Record<BotType, string> = {
  [BotType.SIGNAL]:
    "Revolutionizing auto trading with advanced strategies, full flexibility, and a user-friendly interface, the Signals Bots are suitable for both novice and advanced traders. These smart bots redefine trading automation, offering hassle-free following of expert trades without requiring extensive time or effort.",
  [BotType.ASAP]:
    "Optimize your trading performance with our Smart DCA Bots. Designed to adapt to dynamic market conditions, these bots leverage advanced configurations to automatically buy low and sell high, maximizing returns while reducing risk.",
  [BotType.GRID]:
    "Capitalize on market fluctuations with our Grid Bots. Designed for volatile environments, these bots automatically place buy and sell orders at preset price intervals, allowing you to profit from market swings without constant oversight.",
  [BotType.TRADING_VIEW]:
    "Combine the power of TradingView with Cornix's advanced trading automation. Our TradingView Bots let you use your own alerts and Pine-scripts or copy those you trust to ensure you never miss an opportunity. Trade on your terms automatically and enjoy the perfect blend of world-class indicators and cutting-edge automation.",
};

export const BOT_TYPE_TO_YOUTUBE_EMBED_LINK: Record<BotType, string> = {
  [BotType.SIGNAL]:
    "https://www.youtube.com/embed/_PObjxGyEHI?si=-fl4oLinRA5A0BWX",
  [BotType.ASAP]:
    "https://www.youtube.com/embed/Mtw_DjLXJcY?si=IoBOZMcSVBHWUtM2",
  [BotType.GRID]:
    "https://www.youtube.com/embed/oonfYHeDuaw?si=UwI4posX87sqdyaW",
  [BotType.TRADING_VIEW]:
    "https://www.youtube.com/embed/9T_m4Cu4x4o?si=2FJab5YpCQKFF1Pi",
};

export const BOT_TYPE_TO_MAIN_ARTICLE_ID: Record<BotType, string> = {
  [BotType.SIGNAL]: "8800202",
  [BotType.ASAP]: "6166394",
  [BotType.GRID]: "8253570",
  [BotType.TRADING_VIEW]: "6248036",
};

export const BOT_TYPE_TO_ARTICLE_DATA = {
  [BotType.SIGNAL]: [
    {
      title: "What is the Cornix Signals Bot?",
      description:
        "In the dynamic world of cryptocurrency trading, the Cornix Signals Bot emerges as a sophisticated and user-friendly...",
      id: "8800202",
    },
    {
      title: "How to Use Cornix Signals Bot: A Step-by-Step Guide",
      description:
        "Easily create your Signals Bot with only 2 steps. The Signals Bot automatic...",
      id: "8800211",
    },
    {
      title: "Signals Bot Advanced Settings",
      description:
        "The advanced settings are made for advanced users and allow you full control of the signals bot config...",
      id: "8800218",
    },
  ],
  [BotType.ASAP]: [
    {
      title: "Cornix Smart DCA Bots",
      description:
        "Dollar-cost averaging (DCA) is an investment (buying) strategy that divides the total amount to be invested across...",
      id: "6166394",
    },
    {
      title: "Creating Your Own Smart DCA Bot",
      description:
        'To create a new bot, under the DCA section, navigate to the "My Bots"...',
      id: "6164330",
    },
    {
      title: "Copy Public DCA Bots",
      description:
        "Under the 'Public Bots' page on the DCA section, you can explore and view anonymized public DCA bots...",
      id: "6165998",
    },
  ],
  [BotType.GRID]: [
    {
      title: "What is Grid Bots",
      description:
        "Grid trading is a trading strategy where predefined price levels (known as grids) are established as both buying and selling points...",
      id: "8253570",
    },
    {
      title: "How to Create a Grid Bot",
      description:
        "Cornix Grid Bots are designed to help traders profit by taking advantage of sideway markets price action...",
      id: "8116944",
    },
    {
      title: "Advanced Grid Bot Settings",
      description: `For advanced users to set complex strategies, by clicking the "Advanced Settings button", you'll add the "Grid Type"...`,
      id: "8238208",
    },
  ],
  [BotType.TRADING_VIEW]: [
    {
      title: "What is the Cornix TradingView Bot?",
      description:
        "The Cornix Trading View Bot is an advanced automation tool that allows you to execute trades directly...",
      id: "10751039",
    },
    {
      title: "Create a TradingView Bot",
      description:
        "TradingView Bots will create trades based on a pre-configured strategy when triggered by pre-defined...",
      id: "6248036",
    },
    {
      title: "Create TradingView Alerts and Connect them to your Bot",
      description:
        "Currently, TradingView integration with Cornix is only possible by using the Webhook URL method...",
      id: "6325118",
    },
  ],
};

export const DRAWER_BACKTESTING_QUERY_PARAM = "drawer-backtesting";
export const APPLIED_BACKTESTING_QUERY_PARAM = "backtesting";
export const BACKTESTING_BOT_QUERY_PARAM = "backtesting-bot";
export const GROUP_ID_QUERY_PARAM = "group-id";
export const COPY_TO_WORKSPACE_QUERY_PARAM = "copy-to-workspace";
export const BOT_RANK_QUERY_PARAM = "bot-rank";

export const MOBILE_LAYOUT = 650;
export const BOT_FORM_BOTTOM_SPACE = 40;

export const NEW_BOT_ID_QUERY_PARAM = "new-bot";
